import React from 'react';

const InlineInput: any = (props: any) => {
  const {
    className,
    labelClassName,
    style,
    getFilesFromEvent,
    accept,
    multiple,
    disabled,
    onFiles,
    files,
  } = props;

  return (
    <label
      className={files.length > 0 ? 'btn btn-default' : labelClassName}
      style={styles.label}
    >
      {files.length === 0 && (
        <span className="text-center dropzone-button-wrapper">
          <p>Drop Files to Upload</p>
          <p>or</p>
          <span className="btn-neutral btn-icon btn btn-default">
            <span className="btn-inner--text">
              Upload file(s) from computer
            </span>
          </span>
        </span>
      )}

      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async (e): Promise<any> => {
          const target: any = e.target;
          const chosenFiles: any = await getFilesFromEvent(e);
          onFiles(chosenFiles);
          target.value = null;
        }}
      />
    </label>
  );
};

const styles: any = {
  label: {
    backgroundColor: '#fff',
    padding: '1rem',
    position: 'relative',
    zIndex: 2,
  },
};

export default InlineInput;
